const COLUMN_LIST_DATA = [
  // " ",
  "일자",
  "시간",
  "지종",
  "기준 평량",
  "작업 호기",
  "SPEED\n[m/min]",
  "실평량\n[g]",
  "수분\n[%]",
  "두께\n[μm]",
  "밀도\n[g/㎠]", 
  "MD 압강\n[kgf]",
  "CD 압강\n[kgf]",
  "CD Index\n[kgf/g/㎡]",
  "MD/CD",
  "파강\n[kgf]",
  "파강 Index\n[kgf/g/㎡]",
  "색상 L",
  "색상 A",
  "색상 B",
  "Cobb size\n[g/㎡]",
  "Cobb 온도\n[ºC]",
  "Cobb 습도\n[%]",
  "여분 1",
  "여분 2",
  "여분 3",
  "여분 4",
  "여분 5",
  "여분 6",
  "여분 7",
  "여분 8",
];

export default COLUMN_LIST_DATA;